import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=ff32bd64&scoped=true"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff32bd64",
  null
  
)

export default component.exports